export default {
  通话明细: 'Call Details',
  通话视角: 'Call Perspective',
  人员视角: 'Personnel Perspective',
  下载: 'Download',
  查看录音: 'View Recording',
  查看详情: 'View Details',
  数据概览: 'Data Overview',
  通话时长: 'Call Duration',
  接通次数: 'Number of Connections',
  有效通话数: 'Number of Valid Calls',
  无效通话数: 'Number of Invalid Calls',
  电话总数: 'Number of Phone Numbers',
  通话时间大于等于1分钟: 'Call Time is Greater than or Equal to 1 Minute',
  通话时间小于1分钟: 'Call Time is Less than 1 Minute',
  已接通和未接通的电话总数: 'Phone Number of Connections and Unconnections',
  日程明细: 'Schedule Details',
  日程视角: 'Schedule Perspective',
  会议妙记: 'Meeting Memo',
  申请入会: 'Apply for Membership',
  跟进方式: 'Follow-up Method',
  该线索已删除: 'The Lead Has Been Deleted',
  日程: 'Schedule',
  日程数: 'Number of Schedules',
  开始时间升序: 'Start Time Ascending',
  开始时间降序: 'Start Time Descending',
  结束时间升序: 'End Time Ascending',
  结束时间降序: 'End Time Descending',
  重点: 'Key Point',
  暂无数据: 'No Data',
  通话记录: 'Call Record',
  拨打时间升序: 'Call Time Ascending',
  拨打时间降序: 'Call Time Descending',
  通话时长升序: 'Call Duration Ascending',
  通话时长降序: 'Call Duration Descending',
  创建日程: 'Create Schedule',
  线索: 'Lead',
  通话: 'Call',
  日程总数: 'Total schedule',
  未开始日程: 'Unstarted schedule',
  进行中日程: 'In-progress schedule',
  已结束日程: 'Ended schedule',
  日程开始时间: 'Schedule start time',
  日程结束时间: 'Schedule end time',
  日程创建时间: 'Schedule creation time',
  管理员: 'Administrator',
  普通座席: 'Regular seat',
  '输入日程主题/客户名称': 'Enter schedule subject/customer name',
  动态记录视角: 'Tracking Record Perspective',
  人员视角切换: 'Personnel Perspective Switch',
  妙计链接: 'Brilliant Link',
  动态记录创建时间: 'Tracking Record Creation Time',
  动态记录数量: ' Number of Tracking Records',
  '输入客户名称/跟进详情': 'Enter the client name / follow-up details'
};
